var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Document",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.97,4.5 L12.97,4.5 C13.8149957,4.5 14.5,5.18500433 14.5,6.03 L14.5,14.97 C14.5,15.8149957 13.8149957,16.5 12.97,16.5 L-0.97,16.5 C-1.81499567,16.5 -2.5,15.8149957 -2.5,14.97 L-2.5,6.03 C-2.5,5.18500433 -1.81499567,4.5 -0.97,4.5 Z",
    id: "Rectangle",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(6.000000, 10.500000) rotate(90.000000) translate(-6.000000, -10.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,2 L3,1.5 C3,0.671572875 3.67157288,0 4.5,0 L13.5,0 C14.3284271,0 15,0.671572875 15,1.5 L15,15.5 C15,16.3284271 14.3284271,17 13.5,17 L12,17",
    id: "Path",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 12,
    x2: 9.5,
    y2: 12,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 15,
    x2: 9.5,
    y2: 15,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 9,
    x2: 9.5,
    y2: 9,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 6,
    x2: 9.5,
    y2: 6,
    id: "Path-2",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b71a2a9daae2d80d25eef5406563d20a.svg";
export { ForwardRef as ReactComponent };